import { put, takeLatest } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import {
  getPropertyDetailsFailure,
  getPropertyDetailsSuccess,
  getPropertyRecordsFailure,
  getPropertyRecordsSuccess,
} from "./slice";
import { PROPERTY_REQUEST } from "./types";
import { axiosInstance } from "../../utils/AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* getPropertyRecords(action: any) {
  const params = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/propertyrecords`,
      { params }
    );
    yield put(getPropertyRecordsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getPropertyRecordsFailure({ error: err.response?.data }));
  }
}

function* getPropertyDetails(action: any) {
  const { id, ...params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/propertyrecords/${id}`,
      {
        params,
      }
    );
    yield put(getPropertyDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getPropertyDetailsFailure({ error: err.response?.data }));
  }
}

export function* propertySaga() {
  yield takeLatest(
    `${PROPERTY_REQUEST}/getPropertyRecordsRequest`,
    getPropertyRecords
  );
  yield takeLatest(
    `${PROPERTY_REQUEST}/getPropertyDetailsRequest`,
    getPropertyDetails
  );
}
